export default () => ({
    init() {
        this.$el.addEventListener('carousel-change', (event) => {
            const theme =
                event?.detail?.activeSlide?.firstElementChild?.dataset.theme

            if (theme) {
                this.$store.theme = theme
            }

            ;[...this.$el.querySelectorAll('video')].forEach(
                (video) => (video.muted = true)
            )
        })
    },
})
